export default "__VITE_ASSET__gdoqB650__"